import Column from "@/Components/Grid/Column";
import Row from "@/Components/Grid/Row";
import { Trans, useTranslation } from "react-i18next";
import FrontText from "../FrontText";
import { Icon } from "@iconify/react";

const WhatWeOffer = ({ itemsKey, components }) => {
    const { t } = useTranslation();

    return (
        <Row>
            <Column>
                <div className="border-[1px] border-F3F3F3 shadow-what-we-offer py-12 xl:mb-c120 lg:mb-25 md:mb-20 mb-15 px-6">
                    <Row>
                        <Column xl={10} lg={10} md={11} className={`mx-auto`}>
                            <ul className="flex flex-wrap md:gap-y-10 gap-y-8 2xl:gap-x-c130 xl:gap-x-25 lg:gap-x-20 md:gap-x-10 ">
                                {t(itemsKey, { returnObjects: true }).map((item, id) => (
                                    <li key={item} className={`2xl:w-[calc(50%_-_4.0625rem)] xl:w-[calc(50%_-_3.125rem)] lg:w-[calc(50%_-_2.5rem)] md:w-[calc(50%_-_1.25rem)] w-full flex items-start`}>
                                        <Icon icon={`gg:check-o`} width={38} className="text-[#FFE842] mr-[10px] -mt-2 md:w-c38 w-8"/> 
                                        <FrontText textSize='16/20' className="font-semibold w-[calc(100%-48px)]">
                                            <Trans i18nKey={item}
                                                components={components}
                                            />
                                        </FrontText>
                                    </li>
                                ))}
                            </ul>
                        </Column>
                    </Row>
                </div>
            </Column>
        </Row>
    )
}

export default WhatWeOffer;